import { t } from '@/i18n/utils'

/**
 * Setting 页面公共配置
 * 所有品牌共享的文案
 */

export const commonTexts = {
  // 页面标题（NovelMello 顶栏使用；其他品牌顶栏无标题，不受影响）
  get pageTitle() { return t('Setting') },
  get language() { return t('Language') },
  get languageEnglish() { return t('English') },
  get languageTraditionalChinese() { return t('TraditionalChinese') },
  get languageJapanese() { return t('Japanese') },
  get languageKorean() { return t('Korean') },
  get languageFrench() { return t('French') },
  get languageGerman() { return t('German') },
  get languageSpanish() { return t('Spanish') },
  get languageBahasaIndonesia() { return t('BahasaIndonesia') },
  get userAgreement() { return t('UserAgreement') },
  get privacyPolicy() { return t('PrivacyPolicy') },
  get accountCancellation() { return t('Accountcancellation') },
  get autoUnlock() { return t('Auto_unlock') },
  get subscriptionManagement() { return t('SubscriptionManagement') },
  get importantOperation() { return t('AcountCancellationWarn') },
  // 与 en.json 不完全匹配（末尾多了句号），保持为固定值
  get accountCancellationConfirm() { return t('AcountCancellationWarn2') },
  get verify() { return t('Verify') },
  get cancel() { return t('Cancel') },
  get accountCancellationSuccess() { return t('AccountCancellation') },
  get autoUnlockSuccess() { return t('AutoUnlockSetting') },
}

export const settingCommonConfig = {
  texts: commonTexts,
}
